module.exports = __webpack_public_path__ + "assets/img/bg.51c7d110.png";